import { CameraManager } from '../../../babylon/camera/CameraManager.js';
import { log_instance } from '../utils/LogInstance.js';
export const CAMERA_MANAGER_DESCRIPTION = {
    type: CameraManager,
    name: 'camera-manager-description',
    is_enabled: true,
    initiate_tabs: [
        {
            tag: 'Camera Manager',
            setup: (tab, manager) => {
                tab.label('☰ Cameras Stack');
                tab.watch(manager['_camera_stack'], 'size', { is_readonly: true });
                tab.custom.watch('string', {
                    name: 'Peek',
                    get: () => { var _a, _b; return (_b = (_a = manager.active_camera) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null; },
                    is_nullable: true
                });
                tab.button('Pop', { on_click: () => manager.pop_camera() });
                tab.label('📷 Engine Camera');
                tab.watch(manager.engine_camera, 'position', { is_readonly: true });
                tab.watch(manager.engine_camera, 'forward', { is_readonly: true });
                const jitter = tab.container('jitter');
                jitter.custom.watch('number', { name: 'x', get: () => manager.engine_camera.get_jitter().x });
                jitter.custom.watch('number', { name: 'y', get: () => manager.engine_camera.get_jitter().y });
                tab.button('Log Engine Camera', { on_click: () => log_instance(manager.engine_camera) });
                tab.button('Log Manager', { on_click: () => log_instance(manager) });
            }
        }
    ]
};
//# sourceMappingURL=CameraManagerDescription.js.map